__turbopack_context__.v({
  "control": "slider-module-scss-module__IcZ7vG__control",
  "controls": "slider-module-scss-module__IcZ7vG__controls",
  "icon-next": "slider-module-scss-module__IcZ7vG__icon-next",
  "icon-prev": "slider-module-scss-module__IcZ7vG__icon-prev",
  "placeholder": "slider-module-scss-module__IcZ7vG__placeholder",
  "skip-link": "slider-module-scss-module__IcZ7vG__skip-link",
  "slide-item": "slider-module-scss-module__IcZ7vG__slide-item",
  "slider": "slider-module-scss-module__IcZ7vG__slider",
  "slides": "slider-module-scss-module__IcZ7vG__slides",
  "teaser-item": "slider-module-scss-module__IcZ7vG__teaser-item",
});
